module.exports = __webpack_public_path__ + "img/fish hunter spongebob.86590f9c.jpg";